// extracted by mini-css-extract-plugin
export default {"title":"bTYi9GHe","mobile":"mobile"};